namespace RedBullMOBILE360.SpecialEvent {
    export interface SpecialEventFile extends Serenity.ServiceRequest {
        EventName?: string;
        ImageUrl?: string;
        UploadDate?: string;
        FileName?: string;
    }
}
